<template>
  <form @submit.prevent="onRegistration"
        class="auth">
    <BasePreloader v-if="pendingAuth"/>
    <BaseInput type="tel"
               v-model="inputs.phone.value"
               :error="inputs.phone.error"
               :placeholder="$t('Телефон')"
               mask="+38 (099) 999-99-99"
               class="auth__input"
    />
    <BaseInput type="password"
               v-model="inputs.password.value"
               :error="inputs.password.error"
               :placeholder="$t('Пароль')"
               class="auth__input"
    />
    <BaseInput type="email"
               v-model="inputs.email.value"
               :error="inputs.email.error"
               placeholder="Email"
               class="auth__input"
    />

    <BaseAlertInline :value="overallErrorsMix" class="_warning"/>

    <div class="auth__buttons">
      <button type="submit" class="auth__btn base-btn">
        {{ $t('Зареєструватись') }}
      </button>
      <button type="button" @click.prevent="onLoginClick"
              class="auth__btn base-btn">
        {{ $t('Вхід') }}
      </button>
    </div>
  </form>
</template>

<script>
  import formMixins from '../mixins/formMixins'
  import {mapState} from 'vuex'

  export default {
    mixins: [formMixins],
    props: {
      redirect: Object
    },
    data() {
      return {
        inputs: {
          phone: {
            value: null,
            required: true
          },
          email: {
            value: null,
            required: true
          },
          password: {
            value: null,
            required: true
          }
        }
      }
    },
    computed: {
      ...mapState('user', ['pendingAuth'])
    },
    methods: {
      onLoginClick() {
        this.$vModal.close('auth-registration')
        this.$vModal.open('auth-login', {
          redirect: this.redirect
        })
      },
      onRegistration() {
        this.resetErrorsMix(this.inputs)
        const sendData = this.createSendDataMix(this.inputs)
        if (!sendData) return
        if (sendData.phone) {
          sendData.phone = `380${sendData.phone}`
        }

        this.$store.dispatch('user/registration', sendData).then(() => {
          this.$vModal.close('auth-registration')
          if (this.redirect) {
            this.$router.push({name: this.redirect.name})
          }
        }).catch(e => {
          this.handlerErrorMix(e, this.inputs)
        })
      }
    }
  }
</script>

<style lang="less">

</style>
